export default class effectManager {
    constructor(manager){

        this.manager = manager;

    }
    show($target,type){

        switch (type){
            case "set":

                for( let n in $target ){
                    if($target[n].nodeType!=1) continue; // dom要素以外は処理止める
                    TweenMax.set($target[n],{
                        opacity:0,
                        scale:1.08,
                        rotation:-1,
                    });
                }

                break;
            case "show":

                TweenMax.to($target, 1.6, {
                    opacity:1,
                    ease: Power2.easeOut,
                });
                TweenMax.to($target, 2.6, {
                    scale:1,
                    rotation:0,
                    ease: Power2.easeOut,
                });

                break;
            case "out":
                break;
        }

    }
    text($target,type){

        switch (type){
            case "set":

                for( let n in $target ){
                    if($target[n].nodeType!=1) continue; // dom要素以外は処理止める
                    for( let l in $target[n].querySelectorAll('.js__show') ) {
                        if ($target[n].querySelectorAll('.js__show')[l].nodeType != 1) continue; // dom要素以外は処理止める
                        if( ( l % 2 ) != 0 ) {
                            TweenMax.set($target[n].querySelectorAll('.js__show')[l],{
                                opacity:0,
                                x:'100px',
                                rotation:1
                            });
                        }else{
                            TweenMax.set($target[n].querySelectorAll('.js__show')[l],{
                                opacity:0,
                                x:'100px',
                                rotation:-1
                            });
                        }
                    }
                }

                break;
            case "show":

                for( let n in $target ) {
                    if ($target[n].nodeType != 1) continue; // dom要素以外は処理止める
                    TweenMax.staggerTo($target[n].querySelectorAll('.js__show'), 1.8, {
                        opacity: 1,
                        x: '0px',
                        rotation:0,
                        ease: Power2.easeOut,
                    },0.08);
                }

                break;
            case "out":
                break;
        }

    }

}
